import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import { SectionHeader } from "./section-header";

export const RedoSection = ({ title, showRedo = true, onRedo, isDisabled = false, showSeparator = true, children }) => (
    <div>
        <div className="justify-content-between align-items-center">
            <SectionHeader>{title}</SectionHeader>
            {showRedo && (
                <button
                    title="Redo"
                    className="button -x-small"
                    onClick={onRedo}
                    disabled={isDisabled}
                >
                    <FontAwesomeIcon icon={faRedo} />
                </button>
            )}
        </div>
        {children}
        {showSeparator && <div className="h-separator" />}
    </div>
);
